import { ChakraBox as Box } from "@airhelp/react-ui-components";

interface PlainContentProps {
  content: string;
}

const contetntStyles = {
  a: {
    color: "primary.500",
    textDecoration: "underline",
  },
  p: {
    mb: 4,
  },
  "li > p": {
    ml: 4,
  },
  li: {
    mb: 4,
    ml: 14,
  },
  "li::marker": {
    fontWeight: "semibold",
    fontSize: "lg",
    color: "primary.500",
  },
  h2: {
    fontSize: "5xl",
    fontWeight: "bold",
  },
  h3: {
    fontSize: "2xl",
    fontWeight: "bold",
  },
};

const PlainContent = ({ content = "" }: PlainContentProps) => (
  <Box sx={contetntStyles} fontSize="lg" dangerouslySetInnerHTML={{ __html: content }} />
);

export default PlainContent;
